const Pdata=[
    {
    "id": 1,
    "title": "Switzerland",
    "image": "https://demo.themexpert.com/wordpress/valley/travel-agency/wp-content/uploads/sites/2/2019/07/region-1.jpg",
    
    },
    {
    "id": 2,
    "title": "Norway",
    "image": "https://demo.themexpert.com/wordpress/valley/travel-agency/wp-content/uploads/sites/2/2019/07/region-3.jpg",
    
    },
    {
        "id": 3,
        "title": "Portugal",
        "image":"https://demo.themexpert.com/wordpress/valley/travel-agency/wp-content/uploads/sites/2/2019/07/region-2.jpg",
        },
    {
    "id": 4,
    "title": "Canada",
    "image": "https://demo.themexpert.com/wordpress/valley/travel-agency/wp-content/uploads/sites/2/2019/07/region-4.jpg",
     },
     
   
]
           
export default Pdata







